import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const deleteEducation = id => {
  return dispatch => {
    dispatch({ type: "DELETE_EDUCATION_LOADING" });
    api
      .educationDelete(id)
      .then(resp => {
        dispatch(operationSucceeded(id));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "DeleteEducationErrorAlertTitle",
          "Virhe poistaessa tutkintoa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = (id) => ({
  type: "DELETE_EDUCATION_SUCCEEDED",
  payload: { education: { educationId: id, rowId: id } }
});

const operationFail = () => ({
  type: "DELETE_EDUCATION_FAIL"
});
